import { render } from "./LogoutPage.vue?vue&type=template&id=8048d8c0&ts=true"
import script from "./LogoutPage.vue?vue&type=script&lang=ts"
export * from "./LogoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__